"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgInLamp = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgInLamp = function SvgInLamp(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.225 1.2A7.424 7.424 0 004.8 8.625c0 2.72 2.49 5.604 3.396 8.137C9.548 20.54 9.398 22.8 12.225 22.8c2.869 0 2.676-2.25 4.03-6.022.908-2.538 3.395-5.453 3.395-8.153A7.425 7.425 0 0012.225 1.2zm1.75 18.344l-3.347.418c-.12-.346-.248-.75-.404-1.278l-.006-.021 4.177-.522-.178.596c-.088.303-.167.567-.242.807zm-3.953-1.531a40.408 40.408 0 00-.415-1.288h5.242c-.083.242-.166.485-.238.715l-4.59.573zm2.203 3.437c-.684 0-.998-.079-1.348-.844l2.86-.358c-.414 1.116-.716 1.202-1.512 1.202zm3.154-6.075h-6.3c-.336-.729-.74-1.458-1.138-2.171-.881-1.577-1.79-3.207-1.79-4.579a6.082 6.082 0 016.074-6.075A6.082 6.082 0 0118.3 8.625c0 1.362-.911 3.001-1.793 4.587-.394.71-.795 1.438-1.128 2.163z",
    fill: "currentColor"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.225 4.575a4.054 4.054 0 00-4.05 4.05.338.338 0 00.675 0 3.379 3.379 0 013.375-3.375.338.338 0 000-.675z",
    fill: "currentColor"
  }));
};

exports.SvgInLamp = SvgInLamp;